<template>
  <main class="content">
    <Hero title="Veelgestelde vragen"/>
    <div class="maxw--body block">
      <p class="mb-2 rendered text--center">
        Een lijst van veelgestelde vragen over verschillende onderwerpen gerelateerd aan woonboten.
      </p>
      <div class="grid--two faq__grid">
        <div>
          <FaqCategory v-for="(group, i) in faqGroups.even" :key="i" :group="group" :wave="false"/>
        </div>
        <div>
          <FaqCategory v-for="(group, i) in faqGroups.odd" :key="i" :group="group" :wave="i <= 0"/>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import type FAQ from "@/typings/strapi/objects/faq";
import type GroupedList from '@/typings/groupedList';

definePageMeta({
  pageTransition: pageTransitionConfig,
});

useHead({
  title: 'Veelgestelde vragen'
});

const { find } = useStrapi();

const { data, pending } = await useAsyncData(
  'faqs',
  () => find<FAQ>('faqs', { populate: ['category'], sort: 'rank:asc' }),
  {
    transform: flattenCollection,
    lazy: true
  }
)

const faqGroups = computed<{ even: GroupedList<FAQ>, odd: GroupedList<FAQ> }>(() => {
  const items: { [key: string]: Array<FAQ> } = {};

  if (data.value) {
    for (const item of data.value) {
      const category = flattenObject(item.category);
      const title = category.id ? category.title : 'Overig';

      if (!items[title]) {
        items[title] = [];
      }

      items[title].push(item);
    }
  }

  const even: GroupedList<FAQ> = [];
  const odd: GroupedList<FAQ> = [];

  Object.entries(items).forEach(([key, value], i) => {
    const item = { title: key, items: value };

    if (i % 2 === 0) {
      even.push(item);
    } else {
      odd.push(item);
    }
  });

  return { even, odd };
})
</script>

<style lang="scss">
.faq__grid {
  align-items: start;
  gap: 2rem;
}

.faq__dividerwave {
  margin: 0.5rem 0 1.95rem;
}
</style>
